module.exports = __webpack_public_path__ + "img/Number=20.462e675e.png";